<template>
  <div class="bg-white">
    <!-- 使用绝对定位将 NavHeader 悬浮在图片上方 -->
    <div class="nav-header-container">
      <NavHeader :activeIndex="'home'" :textColor="'text-dark'" />
    </div>

    <!-- <div>
      <b-img src="@/assets/images/open/home4.png" alt="home" class="product-img" fluid />
    </div> -->



    <!-- 图片容器，设置为全屏 -->
    <div class="image-container">
      <div class="video-container">
        <video loop="" muted="" preload="preload" autoplay="true" x-webkit-airplay="allow" x5-playsinline=""
          webkit-playsinline="" playsinline="true" x5-video-player-type="h5-page"
          x5-video-orientation="landscape|portrait" poster="@/assets/images/open/home4.png"
          style="width: 100%; height: 100%;object-fit:cover;object-position:center center"
          class="section-background-video">
          <source type="video/mp4" src="@/assets/images/open/home3.mp4">
        </video>
        <div class="video-overlay">
          <div class="overlay-text">
            <span class="text-dark fs-lg-50 fs-md-30 fs-sm-30 fs-sm-80">
              <span class="text-white display-3 font-weight-bolder" v-continuous-output="text"></span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="slide_2_mk d-flex align-items-center justify-content-center">
      <b-card no-body style="width: 85%;">
        <div class="row p-30">
          <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
            <div class="media ">
              <div class="media-aside mr-2 align-self-start">
                <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030318184445.png" alt="专业数据团队">
              </div>
              <div class="media-body my-auto">
                <span class="text-dark font-weight-bolder">专业<em style="color: #e87984;">数据团队</em></span>
                <p class="card-text font-small-3 mb-0">提供结构化和详细的数据</p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xl-3 mb-2 mb-xl-0">
            <div class="media">
              <div class="media-aside mr-2 align-self-start">
                <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030318184784.png" alt="人工智能服务">
              </div>
              <div class="media-body my-auto">
                <span class="text-dark font-weight-bolder">人工<em style="color: #e87984;">智能服务</em></span>
                <p class="card-text font-small-3 mb-0">海量数据引擎相结合</p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
            <div class="media">
              <div class="media-aside mr-2 align-self-start">
                <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030318184541.png" alt="体育数据引擎">
              </div>
              <div class="media-body my-auto">
                <span class="text-dark font-weight-bolder" >实时<em style="color: #e87984;">体育数据</em></span>
                <p class="card-text font-small-3 mb-0">全球体育实时赛事数据</p>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-xl-3 mb-2 mb-sm-0">
            <div class="media">
              <div class="media-aside mr-2 align-self-start">
                <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030318184865.png" alt="售后服务">
              </div>
              <div class="media-body my-auto">
                <span class="text-dark font-weight-bolder">靠谱<em style="color: #e87984;">售后服务</em></span>
                <p class="card-text font-small-3 mb-0">提供售后技术服务支持</p>
              </div>
            </div>
          </div>

        </div>
      </b-card>
    </div>

    <!--提供-->
    <div class=" mb-50 apply-content">
      <b-row class="my-2">
        <b-col cols="12" md="12" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
          <span class="fs-30 font-weight-bolder" style="font-weight: bold;color: #0B1D30;">
            SoccerPredictor利用人工智能、足球数据、AI足球预测模型提供
          </span>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col cols="12" md="12" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
          <p>走地大小球、走地让球、走地角球、初盘数据等各种足球比赛进行专业的数据分析预测</p>
        </b-col>
      </b-row>
      <div class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
        <b-row class="mt-10" style="width: 80%;">
          <b-col md="6" xl="4">
            <b-card :img-src="require('@/assets/images/open/AI2.jpg')" img-alt="AI2" img-top
            class="card-profile">
              <div class="profile-image-wrapper">
                <div class="profile-image p-0">
                  <b-avatar size="70" variant="light" :src="require('@/assets/images/football/icon/dxq.png')" />
                </div>
              </div>
              <b-card-body>
                <b-card-title>走地大小球</b-card-title>
                <b-card-text>
                   通过大数据实时采集赛事数据并不断通过自研AI大模型作出大小球预测！
                </b-card-text>
              </b-card-body>
              <!-- card links -->
              <!-- <b-card-body>
                <b-link class="card-link">
                  实时战报
                </b-link>
                <b-link class="card-link">
                  往月战报
                </b-link>
              </b-card-body> -->
            </b-card>
          </b-col>

          <b-col md="6" xl="4">
            <b-card :img-src="require('@/assets/images/open/AI2.jpg')" img-alt="AI2" img-top
            class="card-profile">
              <div class="profile-image-wrapper">
                <div class="profile-image p-0">
                  <b-avatar size="70" variant="light" :src="require('@/assets/images/football/icon/rq.png')" />
                </div>
              </div>
              <b-card-body>
                <b-card-title>走地亚盘</b-card-title>
                <b-card-text>
                   通过大数据实时采集赛事数据并不断通过自研AI大模型作出走地亚盘预测！
                </b-card-text>
              </b-card-body>
              <!-- card links -->
              <!-- <b-card-body>
                <b-link class="card-link" @Click="goHistory">
                  实时战报
                </b-link>
                <b-link class="card-link">
                  往月战报
                </b-link>
              </b-card-body> -->
            </b-card>
          </b-col>

          <b-col md="6" xl="4">
            <b-card :img-src="require('@/assets/images/open/AI2.jpg')" img-alt="AI2" img-top
            class="card-profile">
            <!-- <b-card img-src="@/assets/images/open/AI2.jpg" img-top no-body img-alt="card img" class="card-profile"> -->
              <div class="profile-image-wrapper">
                <div class="profile-image p-0">
                  <b-avatar size="70" variant="light" :src="require('@/assets/images/football/icon/jq.png')" />
                </div>
              </div>
              <b-card-body>
                <b-card-title>走地角球</b-card-title>
                <b-card-text>
                   通过大数据实时采集赛事数据并不断通过自研AI大模型作出走地角球大小球预测！
                </b-card-text>
              </b-card-body>
              <!-- card links -->
              <!-- <b-card-body>
                <b-link class="card-link">
                  实时战报
                </b-link>
                <b-link class="card-link">
                  往月战报
                </b-link>
              </b-card-body> -->
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center apply-content">
      <b-card no-body style="width: 95%;background: #eff5ff;border-radius: 20px;">
        <div class="d-flex align-items-center justify-content-center mt-50">
          <h1 style="font-weight: bold;color: #0B1D30; " class="display-4">
            简单易用、长红专家、胜率稳定、最优投注策略
          </h1>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-20">
          <b-card no-body style="width: 85%;padding-left:50px;padding-right:20px;
          border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);">
            <b-row class="my-2">
              <b-col cols="12" md="6">
                <h1>一键登录，系统自动推单，</h1>
                <h1>最优策略数据即时显。</h1>
                <div class="d-flex align-items-center mt-25">
                  <div class="d-flex align-items-center mr-2">
                    <span class="b-avatar badge-light-success rounded">
                      <span class="b-avatar-custom"><img src="@/assets/images/icons/toolbox.svg" alt="avatar img"
                          class=""></span>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0"> 一键安装 </h5><small>one-key setup</small>
                    </div>
                  </div>
                  <div class="d-flex align-items-center ms-30">
                    <span class="b-avatar badge-light-primary rounded">
                      <span class="b-avatar-custom"><img src="@/assets/images/icons/speaker.svg" alt="avatar img"
                          class=""></span>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0"> 自动推送 </h5><small>Automatic push</small>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center mt-25">
                  <div class="d-flex align-items-center mr-2">
                    <span class="b-avatar badge-light-info rounded">
                      <span class="b-avatar-custom"><img src="@/assets/images/icons/star.svg" alt="avatar img"
                          class=""></span>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0"> 最优推荐 </h5><small>Best recomme</small>
                    </div>
                  </div>
                  <div class="d-flex align-items-center ms-30">
                    <span class="b-avatar badge-light-danger rounded">
                      <span class="b-avatar-custom"><img src="@/assets/images/icons/rocket.svg" alt="avatar img"
                          class=""></span>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0"> 场次稳定 </h5><small>Stable sessions</small>
                    </div>
                  </div>
                </div>

                <div class="my-1 py-25 mt-30">
                  <a class=""><span class="badge mr-75 badge-light-danger badge-pill"> 走地大小球 </span></a>
                  <a class=""><span class="badge mr-75 badge-light-success badge-pill"> 走地亚盘 </span></a>
                  <a class=""><span class="badge mr-75 badge-light-primary badge-pill"> 走地角球 </span></a>
                  <a class=""><span class="badge mr-75 badge-light-info badge-pill"> 初盘数据 </span></a>
                </div>


              </b-col>

              <b-col cols="12" md="6" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 10px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/home.png" alt="home" class="product-img" fluid />
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <b-card no-body style="width: 85%;padding-left:20px;padding-right:10px;border-radius: 20px;">
            <b-row class="my-2">
              <b-col cols="12" md="5" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
                <!-- <div class="d-flex align-items-center justify-content-center">
                  <b-img src="@/assets/images/open/home4.png" alt="home" class="product-img" fluid />
                </div> -->

                <div class="card text-white"><!----><!---->
                  <div class="position-relative">
                    <img src="@/assets/images/open/red.png" alt="card img" class="card-img">
                    <div class="card-body card-img-overlay bg-overlay"><!----><!---->
                      <h4 class="card-title text-white"> AI加持长虹战士 </h4>
                      <p class="card-text"> 基于大数据和人工智能技术，处理海量的历史比赛数据，构建更全面的预测模型，跨领域的数据融合，
                        SoccerPredictor提供的全面预测方案具有较高的准确率. </p>
                      <p class="card-text"><small class="text-muted">稳定70%以上准确率</small></p>
                    </div><!---->
                  </div><!----><!---->
                </div>
              </b-col>
              <b-col cols="12" md="7">
                <div class="card-body ">
                  <h1 class="card-title display-1" style="font-weight: bold;color: #0B1D30; ">
                    行业顶尖的数据分析团队，先进的大数据算法与机器学习技术</h1>
                  <h6 class="card-subtitle text-muted mb-5">深耕行业十余年的数据分析经验</h6>
                  <img src="@/assets/images/open/red2.png" class="mb-5 img-fluid ">
                  <p class="card-text mt-10">对全球各大体育赛事进行深度剖析，从球队历史交锋、近期状态、球员伤病情况到赛事赔率波动，
                    我们力求捕捉每一个可能影响比赛结果的细微因素， 为您呈现最全面、最精准的竞彩数据报告.</p>
                  <button type="button" class="btn btn-primary" style="position: relative;"  @click="goDwonload()"> 立即下载 </button>
                  <!-- <a href="#" target="_self" class="card-link"> 实时胜率
                  </a><a href="#" target="_self" class="card-link"> 往月胜率 </a> -->
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <b-card no-body class="bg-light-warning" style="width: 85%;padding-left:20px;padding-right:20px;
          border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);">
            <div class='d-flex align-items-center justify-content-center'>
              <h1 class="mt-20 text-center">实时战报、往月战报可查，胜率说话！</h1>
            </div>
            <b-row class="my-2">
              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/sszb2.png" alt="home" class="product-img" fluid />
                </div>
                <div class="mt-20 text-right">
                  <button type="button" class="btn btn-primary" style="position: relative;"  @click="goReal()"> 实时战报查看 </button>
                </div>

              </b-col>

              <b-col cols="12" md="6">
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/his.png" alt="home" class="product-img" fluid />
                </div>
                <div class="mt-20 ">
                  <button type="button" class="btn btn-danger" style="position: relative;" @click="goHistory()"> 往月战报查看 </button>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <b-card no-body class="bg-light-success" style="width: 85%;padding-left:20px;padding-right:20px;
          border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);">
            <div >
              <h1 class="mt-20 text-center">特色重心推荐（3道关卡层层把控）！</h1>
              <h2 class="mt-20 text-center">最近25场，<span class="text-danger">21红</span>，3黑，1走水</h2>
            </div>
            <b-row class="my-2">
              <b-col md="6" xl="4">
                <b-card img-src="@/assets/images/open/AI2.jpg" img-top img-alt="card img" title="AI大模型预测" class="mb-3 text-dark">
                  <b-card-text>
                    第一步：同步采集全球赛事，对每场比赛都通过自研AI大模型预测平台，进行赛前和赛时分析预测，得到初步的分析列表。
                  </b-card-text>
                  <b-card-text>
                    <b-avatar size="30" variant="light-danger">
                      <feather-icon size="22" icon="ActivityIcon" />
                    </b-avatar>
                    <span class="fw-bold text-danger text-badge d-inline-block me-10 ms-10">
                      <h6 class="fw-black mb-0 ">精准预测</h6>
                    </span>
                  </b-card-text>
                </b-card>
              </b-col>

              <b-col md="6" xl="4">
                <b-card img-src="@/assets/images/open/GL2.jpg" img-top img-alt="card img" title="预设条件过滤" class="mb-3 text-dark">
                  <b-card-text>
                    第二步：通过精心预设的条件，系统能够智能过滤掉那些低赔率且胜率不佳的数据，确保每一条推荐都基于深度分析与科学评估。
                  </b-card-text>
                  <b-card-text>
                    <b-avatar size="30" variant="light-info">
                      <feather-icon size="22" icon="AlertCircleIcon" />
                    </b-avatar>
                    <span class="fw-bold text-parmary text-badge d-inline-block me-10 ms-10">
                      <h6 class="fw-black mb-0">智能过滤</h6>
                    </span>
                  </b-card-text>
                </b-card>
              </b-col>

              <b-col md="6" xl="4">
                <b-card img-src="@/assets/images/open/ZJ2.jpg" img-top img-alt="card img" title="足球专家操盘" class="mb-3 text-dark">
                  <b-card-text>
                    第三步：根据前面过滤出来的数据，SoccerPredictor足球专家团队，进一步进行人工分析、筛选，最终得出最优的策略。
                  </b-card-text>
                  <b-card-text>
                    <b-avatar size="30" variant="light-success">
                      <feather-icon size="22" icon="AlertCircleIcon" />
                    </b-avatar>
                    <span class="fw-bold text-success text-badge d-inline-block me-10 ms-10">
                      <h6 class="fw-black mb-0">严格把控</h6>
                    </span>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>

            <div class='d-flex align-items-center justify-content-center mb-20'>
              <button type="button" class="btn btn-warning" style="position: relative;" @click="goRecomm()"> 查看重心推荐 </button>
            </div>
            
            
          </b-card>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <b-card no-body class="bg-light-info" style="width: 85%;padding-left:20px;padding-right:20px;
          border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);">
            <div class='d-flex align-items-center justify-content-center'>
              <h1 class="mt-20 text-center">多种界面风格随心切！</h1>
            </div>
            <b-row class="my-2">
              <b-col cols="12" md="6">
                <div class='d-flex align-items-center justify-content-center'>
                  <h3 class="mt-20 text-center">至尊黑</h3>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 10px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/zddxq2.png" alt="home" class="product-img" fluid />
                </div>

              </b-col>

              <b-col cols="12" md="6">
                <div class='d-flex align-items-center justify-content-center'>
                  <h3 class="mt-20 text-center">皓月白</h3>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 10px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/zddxqcard1.png" alt="home" class="product-img" fluid />
                </div>
                
              </b-col>
            </b-row>
            <div >
              <h1 class="mt-20 text-center">特色技术统计&即时指数</h1>
              <h6 class="mt-20 text-center text-dark">帮助更好分析赛事走向</h6>
            </div>
            <b-row class="my-2">
              <b-col cols="12" md="6">
                <div >
                  <h3 class="mt-20 text-center">技术统计</h3>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 10px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/js.jpg" alt="home" class="product-img" fluid />
                </div>

              </b-col>

              <b-col cols="12" md="6">
                <div >
                  <h3 class="mt-20 text-center">即时指数</h3>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 10px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/zs.jpg" alt="home" class="product-img" fluid />
                </div>
                
              </b-col>
            </b-row>
          </b-card>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <b-card no-body style="width: 85%;padding-left:20px;padding-right:20px;
          border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);">
            <b-row class="my-2">
              <b-col cols="12" md="7">
                <h1 class="mt-20">不断的对研发进行投入，
                  不断的对模型进行调优。</h1>
                <h1 class="mt-20">胜率高才是硬道理，底气才够足。</h1>

                <div class="transaction-item mt-20">
                  <div class="media">
                    <div class="media-aside align-self-start"><span class="b-avatar badge-light-success rounded"
                        style="width: 22px; height: 22px;"><span class="b-avatar-custom"><svg
                            xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-check">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg></span><!----></span></div>
                    <div class="media-body">
                      <h6 class="transaction-title">已累计迭代300多个大小版本，每一次迭代都是进步；</h6>
                    </div>
                  </div>
                </div>
                <div class="transaction-item mt-20">
                  <div class="media">
                    <div class="media-aside align-self-start"><span class="b-avatar badge-light-success rounded"
                        style="width: 22px; height: 22px;"><span class="b-avatar-custom"><svg
                            xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-check">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg></span><!----></span></div>
                    <div class="media-body">
                      <h6 class="transaction-title">每年百万级研发费用投入进行模型调优；</h6>
                    </div>
                  </div>
                </div>
                <div class="transaction-item mt-20">
                  <div class="media">
                    <div class="media-aside align-self-start"><span class="b-avatar badge-light-success rounded"
                        style="width: 22px; height: 22px;"><span class="b-avatar-custom"><svg
                            xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24"
                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" class="feather feather-check">
                            <polyline points="20 6 9 17 4 12"></polyline>
                          </svg></span><!----></span></div>
                    <div class="media-body">
                      <h6 class="transaction-title">我们的信念：提供更优更稳更红的策略数据，胜率又高又硬。</h6>
                    </div>
                  </div>
                </div>

              </b-col>

              <b-col cols="12" md="5" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
                <div class="d-flex align-items-center justify-content-center">
                  <b-img style="border-radius: 20px;box-shadow: 0 -16px 48px -8px rgba(62,75,96,.07058823529411765);"
                    src="@/assets/images/open/home4.png" alt="home" class="product-img" fluid />
                </div>
              </b-col>
            </b-row>
          </b-card>
        </div>




        <!-- Static Content -->
        <template>
          <div class="item-features bg-light-secondary">
            <div class="d-flex align-items-center justify-content-center mb-10">
              <span class="text-dark fs-lg-30 fs-md-30 fs-sm-30 fs-sm-80">
                <span class="text-primary display-5 font-weight-bolder">您有充足的理由选择我们</span>
              </span>

            </div>
            <div class="d-flex align-items-center justify-content-center mb-50">
              <span class="text-dark ">
                <small>高质量的体育分析数据，帮助用户创造更优投注策略。</small>
              </span>

            </div>
            <div class="row text-center">

              <div class="col-12 col-md-3 mb-4 mb-md-0">
                <b-card class="ceo-dongtai">
                  <div class="w-75 mx-auto  ">
                    <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030320135552.png"
                      alt="统计数据">
                    <h4 class="mt-20 mb-20 font-weight-bolder">
                      AI大模型
                    </h4>
                    <p class="card-text">
                      基于大数据和人工智能技术，处理海量的历史比赛数据，构建更全面的预测模型，跨领域的数据融合.
                    </p>
                  </div>
                </b-card>
              </div>
              <div class="col-12 col-md-3 mb-4 mb-md-0">
                <b-card class="ceo-dongtai">
                  <div class="w-75 mx-auto">
                    <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030320135764.png"
                      alt="细化数据">
                    <h4 class="mt-20 mb-20 font-weight-bolder">
                      实时预测
                    </h4>
                    <p class="card-text">
                      凭借卓越的算法模型与实时数据分析能力，实现高命中率预测，覆盖多场赛事且表现稳定.
                    </p>
                  </div>
                </b-card>
              </div>
              <div class="col-12 col-md-3 mb-4 mb-md-0">
                <b-card class="ceo-dongtai">
                  <div class="w-75 mx-auto ">
                    <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030320135629.png"
                      alt="绩效分析">
                    <h4 class="mt-20 mb-20 font-weight-bolder">
                      重心推荐
                    </h4>
                    <p class="card-text">
                      三道关卡层层筛选，推出高胜率高赔率的最优策略数据，确保每一条推荐都基于深度分析与科学评估.
                    </p>
                  </div>
                </b-card>
              </div>
              <div class="col-12 col-md-3 mb-4 mb-md-0">
                <b-card class="ceo-dongtai">
                  <div class="w-75 mx-auto ">
                    <img src="https://www.statsperform.com.cn/wp-content/uploads/2024/03/2024030320135428.png"
                      alt="细化数据">
                    <h4 class="mt-20 mb-20 font-weight-bolder">
                      消息推送
                    </h4>
                    <p class="card-text">
                      拥有高效的消息推送功能，能够实时、精准地将重要信息、通知或个性化内容推送给用户.
                    </p>
                  </div>
                </b-card>
              </div>  
              
            </div>
          </div>
        </template>

        <!-- Static Content -->
        <!-- Slider: Related Products -->
        <!-- <e-commerce-product-details-related-products /> -->
        <!-- <video-player :source="videoSource"></video-player> -->

      </b-card>

    </div>
  </div>
</template>


<script>
import NavHeader from './NavHeader.vue'
import VideoPlayer from './VideoPlayer.vue';


export default {
  components: {
    NavHeader,
    VideoPlayer
  },
  data() {
    return {
      ifShowLogo: false,
      imgWidth: window.innerWidth,
      text: `SoccerPredictor数据驱动足球预测`,
      videoSource: '@/assets/images/open/home3.mp3'
    }
  },
  computed: {


  },
  created() {
    console.log(window.innerWidth);
    if (window.innerWidth <= 768) {
      this.ifShowLogo = true;
    }
  },

  methods: {
    goDwonload() {
      this.$router.push('/DownLoad');
    },
    goHistory(){
      this.$router.push('/HistoryReports');
    },
    goReal(){
      this.$router.push('/RealTimeReports');
    },
    goRecomm(){
      this.$router.push('/RecommendReports');
    }
  },

  // 自定义指令
  directives: {
    // 文字逐一输出
    continuousOutput: {
      bind(el, binding) {
        el.innerHTML = ''
        const wordString = binding.value
        // dom: 指令绑定的元素
        // wordString: 指令绑定的值
        // delay：文字输出的间隔
        // callback: 内容输出结束后的回调函数
        function writing(dom, wordString, delay, callback) {
          let wordIndex = 0
          let htmlContent = ''
          let isTag = false
          let tagBuffer = ''
          const _delay = delay
          function writeNext() {
            if (wordIndex < wordString.length) {
              let currentChar = wordString[wordIndex++]
              if (currentChar === '<') {
                isTag = true
              }

              if (isTag) {
                delay = 0
                tagBuffer += currentChar
                if (currentChar === '>') {
                  isTag = false
                  htmlContent += tagBuffer
                  tagBuffer = ''
                }
              } else {
                delay = _delay
                htmlContent += currentChar
              }

              dom.innerHTML = htmlContent
              setTimeout(writeNext, delay)
            } else if (callback) {
              callback()
            }
          }

          writeNext()
        }
        writing(el, wordString, 100, () => {
          // alert('内容输出完毕')
        })
      }
    }
  },
}
</script>

<style scoped>
.item-features {
  /* background-color: $body-bg; */
  font-family: Microsoft yahei, ProximaNova, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  padding-top: 3.357rem;
  padding-bottom: 3.357rem;
  padding-left: 1.357rem;
  padding-right: 1.357rem;

  i,
  svg {
    font-size: 2.5rem;
    height: 2.5rem;
    width: 2.5rem;
    color: red;
  }
}


.ceo-dongtai:hover {
  transform: translateY(-3px);
  /* -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, .05); */
  /* box-shadow: 0 0 10px rgba(0, 0, 0, .05); */
  -webkit-transform: translateY(-3px);
  -ms-transform: translateY(-3px);
  transform: translateY(-3px);
}
</style>
<style scoped>
.fullscreen-container {
  position: relative;
  /* 设置为相对定位，作为绝对定位元素的参照 */
  width: 100%;
  height: 100vh;
  /* 视口高度 */
  /* overflow: hidden; */
  /* 防止图片溢出 */
}

.nav-header-container {
  position: absolute;
  /* 绝对定位 */
  top: 0;
  /* 顶部对齐 */
  width: 100%;
  /* 宽度占满容器 */
  z-index: 10;
  /* 确保在图片上方 */
  /* 你可以在这里添加更多样式来调整 NavHeader 的外观 */
}

.image-container {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  /* 防止图片溢出 */
}

.fullscreen-image {
  width: 100%;
  /* 宽度占满容器 */
  height: auto;
  /* 高度自适应，保持图片宽高比 */
  /* 如果需要，可以添加其他样式来调整图片显示效果 */
}

/* 文字容器样式 */
.overlay-text {
  position: absolute;
  /* 绝对定位 */
  top: 50%;
  /* 垂直居中，但还需要transform来调整 */
  left: 50%;
  /* 水平居中，但还需要transform来调整 */
  transform: translate(-50%, -50%);
  /* 调整位置以完全居中 */
  text-align: center;
  /* 文本居中 */
  width: 100%;
  /* 宽度可以根据需要调整 */
  /* 你可以添加更多的样式，如字体大小、字体家族等 */
}

/* 针对手机屏幕的媒体查询（小于768px） */
@media (max-width: 767.98px) {
  .overlay-text {
    position: absolute;
    /* 绝对定位 */
    top: 50%;
    /* 垂直居中，但还需要transform来调整 */
    left: 50%;
    /* 水平居中，但还需要transform来调整 */
    transform: translate(-50%, -50%);
    /* 调整位置以完全居中 */
    text-align: center;
    /* 文本居中 */
    width: 100%;
    /* 宽度可以根据需要调整 */
    /* 你可以添加更多的样式，如字体大小、字体家族等 */
  }
}

.video-overlay {
  position: absolute;
  /* 绝对定位，相对于最近的已定位祖先元素（这里是.video-container） */
  top: 0;
  /* 距离顶部0 */
  left: 0;
  /* 距离左侧0 */
  width: 100%;
  /* 宽度与容器相同 */
  height: 100%;
  /* 高度与容器相同 */
  background-color: rgba(70, 70, 70, 0.5);
  /* 白色背景，50%透明度 */
  z-index: 1;
  /* 确保蒙版在视频之上 */
}

.section-background-video {
  width: 100%;
  /* 视频宽度 */
  height: 100%;
  /* 视频高度 */
  object-fit: cover;
  /* 保持视频的宽高比，但完全覆盖容器 */
  object-position: center center;
  /* 视频在容器中的位置 */
}

.video-container {
  position: relative;
  /* 使子元素可以相对于这个容器定位 */
  width: 100%;
  /* 容器宽度 */
  height: 100vh;
  /* 容器高度，这里假设你想让视频全屏显示，所以使用视窗高度 */
  overflow: hidden;
  /* 隐藏超出容器的部分 */
}


.slide_2_mk {
  z-index: 10;
  margin-top: -65px;
  padding-bottom: 50px;
  position: relative;
  font-family: Microsoft yahei, ProximaNova, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

@media (min-width: 960px) {
  .ceo-container {
    padding-left: 40px;
    padding-right: 40px;
  }
}

.ceo-container {
  box-sizing: content-box;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.ceo-container>:last-child {
  margin-bottom: 0;
}

.slide_2_mkbox {
  box-shadow: 0px 0px 29px 0px rgba(185, 185, 185, 0.42);
  padding: 35px;
}

.ceo-background-default {
  background-color: #fff;
}

.ceo-width-1-5 {
  width: 20%;
}

[class*='ceo-width'] {
  box-sizing: border-box;
  width: 20%;
  max-width: 100%;
}

.ceo-grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  list-style: none;
}



.ceo-width-auto {
  width: auto;
}

.ceo-width-expand {
  flex: 1;
  min-width: 1px;
}

.apply-content {
  font-family: Microsoft yahei, ProximaNova, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}
</style>